// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2b966f4a","147":"0711a264","295":"9eee52a9","574":"d2cde548","615":"5fb0e664","796":"b0be186a","818":"4a658302","900":"7e595b1f"}[chunkId] + ".chunk.js";
};